const applicationPluginRoute = Symbol("florisoft.application-plugin-route")

interface ApplicationPluginRouteStaticData {
  readonly [applicationPluginRoute]?: string
}

/** Static data that marks a route as the authorization and activation boundary of a plugin. */
export function createApplicationPluginRouteStaticData(pluginId: string): ApplicationPluginRouteStaticData {
  return { [applicationPluginRoute]: pluginId }
}

/** The id of the plugin whose boundary this route is, or `undefined` for any other route. */
export function getApplicationPluginRouteId(staticData: unknown): string | undefined {
  return (staticData as ApplicationPluginRouteStaticData | undefined)?.[applicationPluginRoute]
}
